import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthConfig = () => {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// =====================================================
// GET CONTENT TILES
// =====================================================

export const getContentTilesApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append("page", payload.page || 1);
    formData.append("limit", payload.limit || 10);
    formData.append("search", payload.search || "");
    formData.append(
      "parent",
      payload.parent || ""
    );
    formData.append(
      "parentType",
      payload.parentType || ""
    );
    formData.append(
      "contentType",
      payload.contentType || ""
    );
    formData.append(
      "category",
      payload.category || ""
    );
    formData.append(
      "downloadStatus",
      payload.downloadStatus || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/list`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load content tiles.",
    };
  }
};

// =====================================================
// CONTENT TILE STATS
// =====================================================

export const getContentTileStatsApi = async (payload = {}) => {
  try {
    const formData = new FormData();
    formData.append("parentType", payload.parentType || "");
    formData.append("contentType", payload.contentType || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/stats`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load tile statistics.",
    };
  }
};

// =====================================================
// GET SINGLE CONTENT TILE
// =====================================================

export const getContentTileApi = async (tileId) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_tile_id",
      tileId
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/view`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load content tile.",
    };
  }
};

// =====================================================
// CREATE CONTENT TILE
// =====================================================

export const createContentTileApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_tile_parent",
      payload.con_tile_parent ?? ""
    );

    formData.append(
      "con_tile_icon",
      payload.con_tile_icon || ""
    );

    formData.append(
      "con_tile_title",
      payload.con_tile_title || ""
    );

    formData.append(
      "con_tile_meta_title",
      payload.con_tile_meta_title || ""
    );

    formData.append(
      "con_tile_keyword",
      payload.con_tile_keyword || ""
    );

    formData.append(
      "con_tile_desc",
      payload.con_tile_desc || ""
    );

    formData.append(
      "con_tile_img",
      payload.con_tile_img || ""
    );

    formData.append(
      "con_tile_download_url",
      payload.con_tile_download_url || ""
    );

    formData.append(
      "con_tile_theme_color",
      payload.con_tile_theme_color || ""
    );

    formData.append(
      "con_tile_cat",
      payload.con_tile_cat ?? ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/create`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to create content tile.",
    };
  }
};

// =====================================================
// UPDATE CONTENT TILE
// =====================================================

export const updateContentTileApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_tile_id",
      payload.con_tile_id ?? ""
    );

    formData.append(
      "con_tile_parent",
      payload.con_tile_parent ?? ""
    );

    formData.append(
      "con_tile_icon",
      payload.con_tile_icon || ""
    );

    formData.append(
      "con_tile_title",
      payload.con_tile_title || ""
    );

    formData.append(
      "con_tile_meta_title",
      payload.con_tile_meta_title || ""
    );

    formData.append(
      "con_tile_keyword",
      payload.con_tile_keyword || ""
    );

    formData.append(
      "con_tile_desc",
      payload.con_tile_desc || ""
    );

    formData.append(
      "con_tile_img",
      payload.con_tile_img || ""
    );

    formData.append(
      "con_tile_download_url",
      payload.con_tile_download_url || ""
    );

    formData.append(
      "con_tile_theme_color",
      payload.con_tile_theme_color || ""
    );

    formData.append(
      "con_tile_cat",
      payload.con_tile_cat ?? ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/update`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to update content tile.",
    };
  }
};

// =====================================================
// DELETE CONTENT TILE
// =====================================================

export const deleteContentTileApi = async (tileId) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_tile_id",
      tileId
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-tiles/delete`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to delete content tile.",
    };
  }
};